import React from 'react'

function InvestorDetails() {
    return (
        <div>
            <h1>Investor Details</h1>
        </div>
    )
}

export default InvestorDetails
